module.exports = __webpack_public_path__ + "static/policy_kvM@2x-b38ca16e41df94749653f60586f6ea02.jpg";